/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { CTAs, Button, SaveButton, DiscardButton } from '@insticator/insticator-ui'; // iui-material
import DataLastUpdated from 'material/callout/datalastupdated/datalastupdated_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/reportcontrols/variations/detail/detailCTAs_styles';



/* ========== ~~~~~~~~~~ DETAIL CTAs ~~~~~~~~~~ ========== */
class DetailCTAs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            run: false,
            saveandrun: false
        };
    }
    componentDidUpdate(prevProps) {
        if(!this.props.currentPage && prevProps.currentPage) { this.resetState(); }
    }
    resetState = () => {
        this.setState({ run: false, save: false, saveandrun: false });
    };
    handleRun = () => {
        if (this.props.navigateInvalid()) {
            this.setState({ run: true });
            this.props.handleRun();
        }
    };
    handleSaveAndRun = () => {
        if (this.props.navigateInvalid()) {
            this.setState({ saveandrun: true });
            this.props.handleRunAndSave();
        }
    };
    handleSave = () => {
        if (this.props.navigateInvalid()) {
            this.props.handleSave();
        }
    };
    render() {
        const isNewBlankReport = !this.props.isReportSaved && !this.props.reportChangeDetected;
        return (
            <div className={`detailCTAs ${this.props.classes.detailCTAs}`}>
                <CTAs name={'runctas'} >
                    <Button
                        variant={'primary'}
                        type={'action'}
                        name={'run'}
                        text={'Run'}
                        handleClick={this.handleRun}
                        operation={`run`}
                        processing={this.state.run && this.props.running}
                        disabled={this.props.running || this.state.saveandrun || this.props.saveReportPending || isNewBlankReport}
                    />
                    <SaveButton
                        variant={'secondary'}
                        removeIcon={true}
                        handleSave={this.handleSaveAndRun}
                        savingData={this.state.saveandrun && (this.props.saveReportPending || this.props.running)}
                        buttonText={'Save and Run'}
                        operation={this.state.saveandrun && this.props.isReportSaved ? 'run' : 'save'}
                        disabled={this.props.isReportSaved || this.props.saveReportPending || isNewBlankReport}
                    />
                </CTAs>
                <CTAs name={'savectas'} >
                    {this.props.reportChangeDetected ? <DiscardButton discardChanges={this.props.discardReportChanges} disabled={this.props.saveReportPending} /> : null}
                    <SaveButton
                        variant={'action'}
                        handleSave={this.handleSave}
                        savingData={!this.state.saveandrun && this.props.saveReportPending}
                        buttonText={this.props.isReportSaved && !this.state.saveandrun ? 'Saved' : null}
                        disabled={this.props.isReportSaved || this.props.saveReportPending || isNewBlankReport}
                    />
                </CTAs>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(DetailCTAs);
